var Logger = (function () {
    function Logger() {
    }
    Logger.prototype.log = function (data) {
        console.log(data);
    };
    return Logger;
}());
export { Logger };
var $log = new Logger();
export default $log;
